import Advertising from "@/components/Advertising/Advertising.vue";
import { adSubdomain, isSmallDevice } from "@/common/functions";

export default {
    components: {
        Advertising
    },
    props: {
        layout: {
            type: String,
            required: true
        },
        noresults: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            subdomain: adSubdomain(this.$route.meta.subdomain)
        };
    },
    methods: {
        isSmallDevice
    }
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js